import { User } from "../types/user";
import AdminLayout from "../layouts/AdminLayout";
import adminRoutes from "./AdminRoutes";
import { Navigate, Route } from "react-router-dom";
import UserLayout from "../layouts/UserLayout";
import userRoutes from "./UserRoutes";

interface ViewProps {
    isAdmin: boolean;
    isAdminView: boolean;
    user: User;
    mlsApproved: boolean;
    maintenance: boolean;
    maintenanceMessage: string | null;
    originalUser: User | null;
    isImpersonating: boolean;
}

const LoggedInView = ({
    isAdmin,
    isAdminView,
    user,
    mlsApproved,
    maintenance,
    maintenanceMessage,
    originalUser,
    isImpersonating
}: ViewProps) => {
    // Use original user for admin privilege checks during impersonation
    const userForAdminCheck = isImpersonating ? originalUser : user;
    const isAdminForCheck = isImpersonating ? false : isAdmin;
    
    if ((isAdminForCheck || userForAdminCheck?.adminRole === "CREATOR") && isAdminView) {        
        return (
            <Route
                element={
                    <AdminLayout
                        isAdmin={isAdmin}
                        user={user}
                        isAdminView={isAdminView}
                    />
                }
            >
                {adminRoutes}
            </Route>
        );
    } else {
        return (
            <Route
                element={
                    <UserLayout
                        isAdmin={isAdmin}
                        user={user}
                        isAdminView={isAdminView}
                        maintenance={maintenance}
                        maintenanceMessage={maintenanceMessage}
                    />
                }
            >
                {userRoutes(mlsApproved, user.mlsWelcome)}
                <Route path="*" element={<Navigate to="/" />} />
            </Route>
        );
    }
};

export default LoggedInView;
